<template>
    <v-switch
            v-model="searchModel"
            color="orange"
            class="mt-2 messages"
            @change="valueChange"
    ></v-switch>
</template>
<script>
    import FiltersGeneral from '../../mixins/FiltersGeneral';

    export default {
        name: "FilterSwitch",
        props:[
            'label',
            'initialModel',
            'chips',
            'multiple',
            'resetFilter',
            'hasExternal',
            'filterKey',
            'filterName',
        ],
        mixins:[FiltersGeneral],
        data() {
            return {
                searchModel: null,
                storeFilterKey: this.filterKey
            }
        },
        computed: {
            storeFilter() {
                const storeFiltersContainer = this.$store.state.filters[this.filterKey] || {};

                return !!storeFiltersContainer[this.filterName] || false;
            },
        },
        methods: {
            checkInitial() {
                this.searchModel = !!this.storeFilter;

            },
            valueChange() {
                const emitData = {
                    name: this.filterName,
                    key: this.filterKey
                };

                if(!this.searchModel) {
                    this.$store.commit('deleteFilter', emitData);
                } else {
                    emitData.value = this.searchModel;
                }

                if(this.filterKey && this.filterName) {
                    if(emitData.value) {
                        this.$store.commit('setFilter', emitData);
                    }
                    this.setStoreFiltersToUrl();
                }

                this.$emit('value-change', emitData);
            }
        },
        watch: {
            resetFilter() {
                this.searchModel = null;
            },
            storeFilter() {
                this.checkInitial();
            }
        },
        created() {
            this.searchModel = this.storeFilter;
        }
    }
</script>

<style scoped>

</style>
